<template>
  <div class="container mx-auto">
    <div class="section-title mt-4">
      Trainingseinheit kopieren
    </div>
    <div
      v-if="session"
      class="flex flex-row"
    >
      <label
        class="block text-grey-darker font-bold mb-1 w-32"
        for="team"
      >Einheit:</label>
      <span class="font-bold">{{ session.title }}</span>
    </div>

    <div class="flex flex-row w-128">
      <label
        class="text-grey-darker font-bold mb-1 w-32"
        for="team"
      >Neues Datum:</label>
      <sc-date-pick
        v-model="session.date"
        class="w-64"
        :monday-first="true"
        :language="de"
        @input="inDateSelect=true"
      />
    </div>
    <div class="">
      <div class="mr-4 flex flex-row w-128 mb-4">
        <label
          class="block text-grey-darker font-bold mb-1 w-32"
          for="team"
        >
          Team
        </label>
        <select
          id="team"
          v-model="session.teamId"
          placeholder="Team wählen"
          class="w-64 appearance-none border-grey-lighter text-grey-darker  focus:outline-none focus:bg-white focus:border-grey appearance-none rounded text-grey-darker focus:outline-none focus:shadow-outline"
          @change="teamSelected"
        >
          <option
            v-for="team in teams"
            :key="team.teamId"
            :value="session.teamId"
          >
            {{ team.name }}
          </option>
        </select>
      </div>

      <div class="mb-8">
        <span
          class="text-xs "
          v-html="session.description"
        />
      </div>
    </div>
    <button
      class="save-button mt-4 w-64 hover:bg-primary-700 hover:border-primary-700"
      type="button"
      @click="save()"
    >
      Speichern
    </button>

    <button
      class="b-1 b-black mt-4 w-64"
      type="button"
      @click="$router.back()"
    >
      Abbrechen
    </button>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TrainingCopy',
    data () {
        return {
            teams: [],
            session: null
        }
    },
    async mounted () {
        await this.loadTeams()
        await this.load()
    },
    methods: {
        async load () {
            this.id = this.$route.params.id
            const response = await apiService.getSsession(this.id)
            this.session = response.data
            this.session.date = new Date(this.session.date)
        },
        async loadTeams () {
            const teams = await apiService.getMyTeams()

            console.log(teams)
            if (teams && teams.status === 200) {
                this.teams = teams.data

                if (this.teams) {
                    const storedTeam = localStorage.getItem('currentTeam')

                    if (storedTeam) {
                        this.selectedTeam = storedTeam
                    } else if (this.teams.length === 1) {
                        this.selectedTeam = this.teams[0].teamId
                        localStorage.setItem('currentTeam', this.selectedTeam)
                    }
                }
            }
        },

        async save () {
            await apiService.copySession(this.session.id, this.session.teamId, this.session.date)
            this.$router.back()
        }
    }

}
</script>

<style scoped>

</style>